import React from 'react'

export enum ColumnType {
  Grouped,
  Inline
}

export enum CellAlignment {
  Center,
  Left,
  Right
}

export interface Column {
  field?: string
  enhancedField?: string
  attributeId?: string //for global table settings
  width?: number
  label: string
  isVisible?: string
  allowFiltering?: boolean
  allowSearch?: boolean
  allowHide?: boolean
  allowReordering?: boolean
  showHeader?: boolean
  showBorders?: boolean
  showHeaderBorder?: boolean
  showHeaderRightBorder?: boolean
  showHierarchyBorder?: boolean
  fixed?: boolean
  cellElement?: React.ElementType
  headerCellElement?: React.ElementType
  hierarchyRowCellTemplate?: React.ElementType
  type?: ColumnType
  columns?: Column[]
  showInColumnChooser?: boolean
  cellAlignment?: boolean
  hierarchyCellAlignment?: CellAlignment
  autoHeight?: boolean
  className?: string
  key?: string
  isStickyBorder?: boolean
  targetMixField?: string // For KPI View
  doorId?: string
  hideDivider?: boolean
  doorIndex?: number
  dateColumnField?: any
  initialAllocationField?: string
  isInitialAllocationDoor?: boolean
}
